import { render, staticRenderFns } from "./v-table.vue?vue&type=template&id=66e397ed"
import script from "./v-table.vue?vue&type=script&lang=js"
export * from "./v-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports